var _style, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-maintenance",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-maintenance:not(.animated) .animable {opacity: 0;}svg#freepik_stories-maintenance.animated #freepik--Gear--inject-38 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-maintenance.animated #freepik--Character--inject-38 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-38",
    style: {
      transformOrigin: "250px 224.82px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "250px 382.525px 0px"
    },
    id: "eljcowhtakk48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.65,
    y: 394.39,
    width: 57.77,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "80.535px 394.515px 0px"
    },
    id: "el0a4abrzu9t8q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.34,
    y: 388.96,
    width: 26.32,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "222.5px 389.085px 0px"
    },
    id: "elvsmt4dffvi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.28,
    y: 388.83,
    width: 51.28,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "270.92px 388.955px 0px"
    },
    id: "elgftoflc9poi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.68,
    y: 391.83,
    width: 12.49,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "387.925px 391.955px 0px"
    },
    id: "els43kk00lloj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.73,
    y: 391.83,
    width: 49.82,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "313.64px 391.955px 0px"
    },
    id: "el3mjfp4ea814",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.1,
    y: 394.39,
    width: 9.9,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "124.05px 394.515px 0px"
    },
    id: "eljn6swxjind",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.33,
    y: 391.83,
    width: 43.25,
    height: 0.25,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "423.955px 391.955px 0px"
    },
    id: "elzqf4p0hynso",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "140.46px 196.4px 0px"
    },
    id: "elgprvuncuyou",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "356.75px 196.4px 0px"
    },
    id: "elzm6k69vbx9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.62,136.81c-4.36-9.42-.9-16.12,9.75-16.12,6.69,0,15,2.64,23,6.93.92-2.45,3.48-3.91,7.61-3.91,7.27,0,17.3,4.53,25.16,10.93a14.53,14.53,0,0,1,8.19-2.44c7-.29,15.38,2.32,22.71,6.56a4.47,4.47,0,0,1,3.23-1.22c4-.16,9.43,2.47,12.13,5.87.17.22.31.42.46.63H74.5A8.5,8.5,0,0,1,76.62,136.81Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "131.616px 132.365px 0px"
    },
    id: "eldime5l4mzzc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.32,92a9.28,9.28,0,0,1,1.06-.06c-.33-3.68,1.58-6,5.65-6,2.94,0,6.54,1.23,10.22,3.31-1.05-7.14,2.31-11.79,9.94-11.79,6.15,0,13.93,3,21.62,8,.67-2.8,2.94-4.48,6.75-4.48,6.68,0,16.19,5.18,23.81,12.5,0,0,0,0,0,0a10.93,10.93,0,0,1,7.37-2.8c6.37-.33,14.27,2.65,21.28,7.51a3.47,3.47,0,0,1,2.9-1.4c3.48-.17,8.28,2.5,11.06,6.09H200.72C197.73,97.39,200.11,92.63,206.32,92Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "263.708px 90.17px 0px"
    },
    id: "elrzvzmkeg19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,76.41c-2.8-6-.57-10.35,6.26-10.35,4.29,0,9.61,1.69,14.79,4.45.58-1.57,2.23-2.52,4.88-2.52,4.67,0,11.1,2.92,16.14,7a9.35,9.35,0,0,1,5.26-1.56c4.46-.19,9.87,1.48,14.57,4.21a2.85,2.85,0,0,1,2.07-.79,10.74,10.74,0,0,1,7.79,3.77l.3.4H373.51C371.12,78.9,373.76,76.51,377,76.41Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "410.824px 73.54px 0px"
    },
    id: "elmrw2960wfy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.15,
    y: 273.52,
    width: 34.06,
    height: 108.88,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "106.18px 327.96px 0px"
    },
    id: "el0uzsc1mefe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elvidf1pza1k"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112.07,
    y: 235.63,
    width: 55.85,
    height: 146.77,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "139.995px 309.015px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.93,
    y: 235.63,
    width: 28.99,
    height: 146.77,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "182.425px 309.015px 0px"
    },
    id: "ely6q6uds4kus",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elizg20hl88ad"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.59,
    y: 221.04,
    width: 48.34,
    height: 14.59,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "143.76px 228.335px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "eld7jta1ivfm8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.59,
    y: 232.35,
    width: 48.34,
    height: 3.28,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "143.76px 233.99px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.93,
    y: 221.04,
    width: 21.47,
    height: 14.59,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.665px 228.335px 0px"
    },
    id: "elu1mcgvcs0c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elp3ss6a2ajmn"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.11,
    y: 206.45,
    width: 40.82,
    height: 14.59,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "147.52px 213.745px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elrure9oxmhi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.11,
    y: 217.76,
    width: 40.82,
    height: 3.28,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "147.52px 219.4px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 167.93,
    y: 206.45,
    width: 13.96,
    height: 14.59,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "174.91px 213.745px 0px"
    },
    id: "el8qigjekdibi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.14,
    y: 186.07,
    width: 2.71,
    height: 20.39,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "154.495px 196.265px 0px"
    },
    id: "elxzkv4apdfyr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq9xhiu51tmi"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.66,
    y: 261.15,
    width: 40.79,
    height: 121.25,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "208.055px 321.775px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 228.45,
    y: 261.15,
    width: 21.17,
    height: 121.25,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "239.035px 321.775px 0px"
    },
    id: "elv8511pfzmiq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.03 295.79 269.96 322.31 269.96 382.4 239.03 382.4 239.03 295.79",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "254.495px 339.095px 0px"
    },
    id: "el7kxg1xdv8xf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.97,
    y: 322.3,
    width: 16.05,
    height: 60.09,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "277.995px 352.345px 0px"
    },
    id: "elitgnloq8jx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "286.02 322.31 269.96 322.31 239.03 295.79 255.09 295.79 286.02 322.31",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "262.525px 309.05px 0px"
    },
    id: "elunh9vuxwz1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431,382.4a14.68,14.68,0,0,1,8.71-10.93,18.39,18.39,0,0,0-2.56,10.93Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "435.355px 376.935px 0px"
    },
    id: "eldy9qqplqada",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.53,382.4a14.68,14.68,0,0,0-8.71-10.93,18.39,18.39,0,0,1,2.56,10.93Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "138.175px 376.935px 0px"
    },
    id: "el0nuzsrzttgc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.11,382.4s-.49-12.8-5.84-16.52C67.46,371.11,67,382.4,67,382.4Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "68.19px 374.14px 0px"
    },
    id: "elsh1h1ku1t19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1,382.4s.49-7.35,5.84-9.48c-2.19,3-1.71,9.48-1.71,9.48Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "72.02px 377.66px 0px"
    },
    id: "el5yz685pysur",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.11,382.4s-.54-12.12-10.24-16.52c4.34,6.22,4.09,16.52,4.09,16.52Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "141.99px 374.14px 0px"
    },
    id: "elxc4gb8a6zrp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,366H361.78a1,1,0,0,1-1-1V340.52a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1V365A1,1,0,0,1,386.29,366Zm-23.51-2h22.51V341.52H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 352.76px 0px"
    },
    id: "eloof8qayvnni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,341.52H361.78a1,1,0,0,1-1-1V316a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.52A1,1,0,0,1,386.29,341.52Zm-23.51-2h22.51V317H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 328.26px 0px"
    },
    id: "el2wczflzbf2b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,366a1,1,0,0,1-.7-.3l-24.52-24.51a1,1,0,1,1,1.42-1.42L387,364.33a1,1,0,0,1,0,1.41A1,1,0,0,1,386.29,366Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.033px 352.738px 0px"
    },
    id: "elvsfxwpnoi2m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,341.52a1,1,0,0,1-.7-.29l-24.52-24.52a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L387,339.81a1,1,0,0,1-.71,1.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.038px 328.262px 0px"
    },
    id: "eld85qqbipnue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,317H361.78a1,1,0,0,1-1-1V291.49a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1V316A1,1,0,0,1,386.29,317Zm-23.51-2h22.51V292.49H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 303.745px 0px"
    },
    id: "elrlgwsh3qozq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,292.49H361.78a1,1,0,0,1-1-1V267a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.52A1,1,0,0,1,386.29,292.49Zm-23.51-2h22.51V268H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 279.245px 0px"
    },
    id: "ela6djjjdf9tn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,317a1,1,0,0,1-.7-.29l-24.52-24.52a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L387,315.3a1,1,0,0,1,0,1.41A1,1,0,0,1,386.29,317Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 303.742px 0px"
    },
    id: "elyrfmm5npua",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,292.49a1,1,0,0,1-.7-.3l-24.52-24.51a1,1,0,0,1,1.42-1.42L387,290.78a1,1,0,0,1,0,1.41A1,1,0,0,1,386.29,292.49Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.033px 279.228px 0px"
    },
    id: "elojkqvffe27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,268H361.78a1,1,0,0,1-1-1V242.45a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1V267A1,1,0,0,1,386.29,268Zm-23.51-2h22.51V243.45H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 254.725px 0px"
    },
    id: "el2d52453d34k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,243.45H361.78a1,1,0,0,1-1-1V217.94a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.51A1,1,0,0,1,386.29,243.45Zm-23.51-2h22.51V218.94H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 230.195px 0px"
    },
    id: "elr57ghhfv5x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,268a1,1,0,0,1-.7-.29l-24.52-24.52a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L387,266.26a1,1,0,0,1-.71,1.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.038px 254.742px 0px"
    },
    id: "elcwkp17vfdkt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,161.55H337.26a1,1,0,0,1-1-1V136a1,1,0,0,1,1-1h24.52a1,1,0,0,1,1,1v24.51A1,1,0,0,1,361.78,161.55Zm-23.52-2h22.52V137H338.26Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "349.52px 148.275px 0px"
    },
    id: "elzmhh9tes8om",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,161.55H361.78a1,1,0,0,1,0-2h23.51v-48a1,1,0,1,1,2,0v49A1,1,0,0,1,386.29,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 136.05px 0px"
    },
    id: "elvr4v9tglin",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.78,161.55a1,1,0,0,1-.9-1.45l24.52-49a1,1,0,0,1,1.34-.44,1,1,0,0,1,.45,1.34l-24.52,49A1,1,0,0,1,361.78,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.034px 136.052px 0px"
    },
    id: "el0o313ukxokji",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26,161.55H312.75a1,1,0,0,1-1-1V136a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.51A1,1,0,0,1,337.26,161.55Zm-23.51-2h22.51V137H313.75Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "325.005px 148.275px 0px"
    },
    id: "eljpdp33p7xcd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.26,161.55a1,1,0,0,1-.7-1.7l24.51-24.52a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41L338,161.26A1,1,0,0,1,337.26,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "349.527px 148.292px 0px"
    },
    id: "el1pe8osz0c6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,161.55H386.29a1,1,0,0,1-1-1V136a1,1,0,0,1,1-1h24.52a1,1,0,0,1,1,1v24.51A1,1,0,0,1,410.81,161.55Zm-23.52-2h22.52V137H387.29Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.55px 148.275px 0px"
    },
    id: "elu0do371bt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,161.55a1,1,0,0,1-.7-1.7l24.51-24.52a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41L387,161.26A1,1,0,0,1,386.29,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "398.557px 148.292px 0px"
    },
    id: "elgp4d8vmpsn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.2,161.55a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41L263,135.33a.91.91,0,0,1,.51-.27L386.1,110.54a1,1,0,0,1,.9.27l49,49a1,1,0,1,1-1.41,1.41L386,112.61,264.21,137l-24.31,24.3A1,1,0,0,1,239.2,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.274px 136.045px 0px"
    },
    id: "el5qhp1w7mfyx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,161.55a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41l24.52-24.52a1,1,0,0,1,1.41,1.41l-24.52,24.52A1,1,0,0,1,312.75,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "324.98px 148.32px 0px"
    },
    id: "elu92yvwbl3xr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.75,161.55H288.23a1,1,0,0,1-1-1V136a1,1,0,0,1,1-1h24.52a1,1,0,0,1,1,1v24.51A1,1,0,0,1,312.75,161.55Zm-23.52-2h22.52V137H289.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "300.49px 148.275px 0px"
    },
    id: "elsaa762eo33c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,161.55H263.71a1,1,0,0,1-1-1V136a1,1,0,0,1,1-1h24.52a1,1,0,0,1,1,1v24.51A1,1,0,0,1,288.23,161.55Zm-23.52-2h22.52V137H264.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.97px 148.275px 0px"
    },
    id: "elnmmb5mfu95",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.23,161.55a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.41L312,135.33a1,1,0,0,1,1.41,1.41l-24.51,24.52A1,1,0,0,1,288.23,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "300.44px 148.32px 0px"
    },
    id: "elh5bc52q4s0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,161.55a1,1,0,0,1-.7-1.7l24.51-24.52a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41l-24.52,24.52A1,1,0,0,1,263.71,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "275.977px 148.292px 0px"
    },
    id: "eluq0zx2p8k9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.71,161.55H239.2a1,1,0,0,1,0-2h23.51V136a1,1,0,0,1,2,0v24.51A1,1,0,0,1,263.71,161.55Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "251.455px 148.275px 0px"
    },
    id: "elc02qyuq8fbn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,243.45a1,1,0,0,1-.7-.29l-24.52-24.51a1,1,0,1,1,1.42-1.42L387,241.75a1,1,0,0,1,0,1.41A1,1,0,0,1,386.29,243.45Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.033px 230.193px 0px"
    },
    id: "eldphrbfkxh1j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,218.94H361.78a1,1,0,0,1-1-1V193.42a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.52A1,1,0,0,1,386.29,218.94Zm-23.51-2h22.51V194.42H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 205.68px 0px"
    },
    id: "el94knfm00h48",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,194.42H361.78a1,1,0,0,1-1-1V168.91a1,1,0,0,1,1-1h24.51a1,1,0,0,1,1,1v24.51A1,1,0,0,1,386.29,194.42Zm-23.51-2h22.51V169.91H362.78Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.035px 181.165px 0px"
    },
    id: "eljc9aodftjqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,218.94a1,1,0,0,1-.7-.29l-24.52-24.52a1,1,0,1,1,1.42-1.42L387,217.23a1,1,0,0,1-.71,1.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.036px 205.678px 0px"
    },
    id: "elh7uw11oe2l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.29,194.42a1,1,0,0,1-.7-.29l-24.52-24.52a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0L387,192.71a1,1,0,0,1-.71,1.71Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "374.038px 181.162px 0px"
    },
    id: "elazp5ykjxpqc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.33 160.55 239.2 160.55 263.71 168.91 435.33 168.91 435.33 160.55",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.265px 164.73px 0px"
    },
    id: "elddm9nh3z33b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.33,169.91H263.71a.91.91,0,0,1-.32-.06l-24.52-8.35a1,1,0,0,1,.33-1.95H435.33a1,1,0,0,1,1,1v8.36A1,1,0,0,1,435.33,169.91Zm-171.45-2H434.33v-6.36H245.23Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "337.256px 164.73px 0px"
    },
    id: "ela0wo8kvirtk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eloo6kv0yb0j"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 343.63,
    y: 164.73,
    width: 18.15,
    height: 38.57,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "352.705px 184.015px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 335.18,
    y: 164.73,
    width: 8.44,
    height: 38.57,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "339.4px 184.015px 0px"
    },
    id: "eltzdrqdq4ot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el20ztglfv99f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 364.48,
    y: 365.04,
    width: 35.74,
    height: 17.36,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "382.35px 373.72px 0px",
      transform: "rotate(180deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 347.85,
    y: 365.04,
    width: 16.63,
    height: 17.36,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "356.165px 373.72px 0px"
    },
    id: "elmkcfu7w13g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,203.64a1,1,0,0,1-1-1V164.73a1,1,0,1,1,2,0v37.91A1,1,0,0,1,410.81,203.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.81px 183.685px 0px"
    },
    id: "elrl83p9znlf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.81,208.24a3.3,3.3,0,1,1,3.3-3.3A3.3,3.3,0,0,1,410.81,208.24Zm0-4.6a1.3,1.3,0,1,0,1.3,1.3A1.3,1.3,0,0,0,410.81,203.64Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "410.81px 204.94px 0px"
    },
    id: "el2syx31e66t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.79,223.54a1,1,0,0,1-1-1V164.73a1,1,0,1,1,2,0v57.81A1,1,0,0,1,266.79,223.54Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "266.79px 193.635px 0px"
    },
    id: "elpal2cts8eol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.18,229.53a1,1,0,0,1-1-.83c-.74-1.16-7.25-5-8.44-5.16-1.12.15-7.63,4-8.37,5.16a1,1,0,0,1-2-.17c0-2.25,9.07-7,10.38-7s10.39,4.74,10.39,7A1,1,0,0,1,276.18,229.53Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "266.753px 225.574px 0px"
    },
    id: "el0z8n5c7j7l0s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287,301.81l14.67-14.67-3.13-6h0c.27-.6.52-1.2.75-1.82h0l6.43-2V256.6l-6.43-2h0c-.24-.61-.48-1.22-.75-1.82l3.12-6L287,232.14l-6,3.12h0c-.6-.27-1.2-.52-1.81-.75l-2-6.43H256.42l-2,6.43c-.61.23-1.21.48-1.81.75h0l-6-3.12L232,246.8l3.13,6c-.28.6-.52,1.21-.76,1.82l-6.43,2v20.74l6.43,2h0c.24.62.48,1.22.75,1.82h0l-3.12,6,14.67,14.67,6-3.13c.6.27,1.21.52,1.82.75h0l2,6.43h20.75l2-6.43c.61-.23,1.21-.48,1.81-.75Zm-9.25-23.93a15.44,15.44,0,1,1,0-21.83A15.42,15.42,0,0,1,277.71,277.88Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "266.83px 266.99px 0px"
    },
    id: "elhqk0zcmv4he",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-38",
    style: {
      transformOrigin: "250px 416.24px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "250px 416.24px 0px"
    },
    id: "ela0z0k4kp70a",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-38",
    style: {
      transformOrigin: "169.65px 177.205px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.89,163.15H163.41a3.27,3.27,0,0,0-2.82,1.62l-6.24,10.81a3.27,3.27,0,0,0,0,3.26l6.24,10.8a3.25,3.25,0,0,0,2.82,1.63h12.48a3.25,3.25,0,0,0,2.82-1.63l6.24-10.8a3.27,3.27,0,0,0,0-3.26l-6.24-10.81A3.27,3.27,0,0,0,175.89,163.15Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "169.65px 177.21px 0px"
    },
    id: "eludociy8upg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el5zgsnrq5oar"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.89,163.15H163.41a3.27,3.27,0,0,0-2.82,1.62l-6.24,10.81a3.27,3.27,0,0,0,0,3.26l6.24,10.8a3.25,3.25,0,0,0,2.82,1.63h12.48a3.25,3.25,0,0,0,2.82-1.63l6.24-10.8a3.27,3.27,0,0,0,0-3.26l-6.24-10.81A3.27,3.27,0,0,0,175.89,163.15Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "169.65px 177.21px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M96,127.33l-.71-.71,6-6,.71.71ZM106.33,117l-.71-.71,12.54-12.54.71.7Z",
    style: {
      fill: "rgb(64, 123, 255)",
      transformOrigin: "107.08px 115.54px 0px"
    },
    id: "el1dxge5nphps",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elenpvsqlnbfn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96,127.33l-.71-.71,6-6,.71.71ZM106.33,117l-.71-.71,12.54-12.54.71.7Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "107.08px 115.54px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,199.84V154.58l-14-4.39h0c-.5-1.34-1.05-2.66-1.63-4h0l6.81-13-32-32-13,6.82h0c-1.31-.59-2.62-1.14-4-1.65l-4.39-14H147l-4.38,14h0c-1.35.51-2.66,1.06-4,1.65l-13-6.82-32,32,6.82,13c-.59,1.31-1.14,2.62-1.64,4h0l-14,4.39v45.26l14,4.38c.51,1.34,1.06,2.66,1.64,4l-6.82,13,32,32,13-6.82h0c1.3.59,2.61,1.14,4,1.65h0l4.38,14h45.26l4.39-14c1.34-.51,2.65-1.06,4-1.65h0l13,6.82,32-32-6.82-13c.58-1.3,1.14-2.62,1.64-4ZM203.33,177.2a33.68,33.68,0,1,1-33.68-33.68A33.69,33.69,0,0,1,203.33,177.2Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "169.65px 177.205px 0px"
    },
    id: "elk9phx2yb24",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el20x6f3qbf81"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.5,199.84V154.58l-14-4.39h0c-.5-1.34-1.05-2.66-1.63-4h0l6.81-13-32-32-13,6.82h0c-1.31-.59-2.62-1.14-4-1.65l-4.39-14H147l-4.38,14h0c-1.35.51-2.66,1.06-4,1.65l-13-6.82-32,32,6.82,13c-.59,1.31-1.14,2.62-1.64,4h0l-14,4.39v45.26l14,4.38c.51,1.34,1.06,2.66,1.64,4l-6.82,13,32,32,13-6.82h0c1.3.59,2.61,1.14,4,1.65h0l4.38,14h45.26l4.39-14c1.34-.51,2.65-1.06,4-1.65h0l13,6.82,32-32-6.82-13c.58-1.3,1.14-2.62,1.64-4ZM203.33,177.2a33.68,33.68,0,1,1-33.68-33.68A33.69,33.69,0,0,1,203.33,177.2Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "169.65px 177.205px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M190.08,259.31H149.23a.25.25,0,0,1-.24-.18l-4-12.62a.25.25,0,0,1,.48-.15l3.89,12.45h40.48L194,245.67a.26.26,0,0,1,.15-.16l1.37-.51c1.16-.44,2.39-.95,3.78-1.57l1.33-.6a.25.25,0,0,1,.2.46l-1.33.59c-1.39.63-2.64,1.14-3.8,1.58l-1.26.48-4.12,13.19A.26.26,0,0,1,190.08,259.31Zm23-9.53a.29.29,0,0,1-.18-.07.25.25,0,0,1,0-.36l28.76-28.75-6.39-12.2a.24.24,0,0,1,0-.22l.6-1.33c.6-1.35,1.11-2.59,1.56-3.77l.51-1.37a.26.26,0,0,1,.16-.15l13.15-4.11V157l-13-4.06a.25.25,0,1,1,.15-.47l13.14,4.1a.26.26,0,0,1,.17.24v40.85a.25.25,0,0,1-.17.24L238.37,202l-.47,1.26c-.45,1.19-1,2.43-1.58,3.8l-.54,1.22,6.41,12.25a.24.24,0,0,1,0,.29l-28.88,28.89A.31.31,0,0,1,213.09,249.78Zm-86.87,0a.29.29,0,0,1-.18-.07L97.15,220.82a.26.26,0,0,1,0-.29l6.47-12.36a.26.26,0,0,1,.34-.11.25.25,0,0,1,.1.34l-6.38,12.2,28.75,28.75a.25.25,0,0,1,0,.36A.28.28,0,0,1,126.22,249.78Zm17-4.49-.09,0c-1-.39-2.09-.85-3.3-1.39a.25.25,0,1,1,.2-.45c1.2.53,2.27,1,3.28,1.37a.25.25,0,0,1,.14.33A.24.24,0,0,1,143.19,245.29Zm26.46-31.14a37,37,0,0,1-36.93-37,.25.25,0,0,1,.5,0,36.43,36.43,0,1,0,36.43-36.43.25.25,0,0,1,0-.5,36.94,36.94,0,0,1,0,73.88Zm-68-10.73a.27.27,0,0,1-.24-.17l-.47-1.25-13.21-4.13a.25.25,0,0,1-.17-.24V156.78a.26.26,0,0,1,.17-.24l12.63-3.94a.26.26,0,0,1,.32.16.27.27,0,0,1-.17.32L88.05,157v40.48l13.15,4.11a.23.23,0,0,1,.15.15l.52,1.37a.25.25,0,0,1-.14.32Zm0-52h-.09a.26.26,0,0,1-.14-.33c.48-1.28,1-2.5,1.55-3.74a.25.25,0,0,1,.33-.12.25.25,0,0,1,.13.33c-.56,1.22-1.06,2.44-1.54,3.71A.26.26,0,0,1,101.65,151.45Zm134.19-5.71-.12,0a.25.25,0,0,1-.1-.34l6-11.55L236.84,129a.25.25,0,1,1,.35-.35l5,5a.24.24,0,0,1,0,.29l-6.13,11.71A.25.25,0,0,1,235.84,145.74ZM97.33,134a.26.26,0,0,1-.18-.07.26.26,0,0,1,0-.35L126,104.71a.23.23,0,0,1,.29,0l12.25,6.41,1.22-.54c1.18-.53,2.26-1,3.3-1.39a.25.25,0,0,1,.33.14.25.25,0,0,1-.15.32c-1,.41-2.1.86-3.27,1.38l-1.33.6a.28.28,0,0,1-.22,0l-12.2-6.39L97.51,134A.24.24,0,0,1,97.33,134Zm135.52-9.12a.26.26,0,0,1-.18-.07L213,105.19l-12.2,6.39a.22.22,0,0,1-.21,0l-1.33-.6c-1.37-.61-2.61-1.12-3.78-1.57l-1.37-.51a.26.26,0,0,1-.15-.16l-4.11-13.14H149.41l-3.54,11.31a.24.24,0,0,1-.31.16.25.25,0,0,1-.16-.31L149,95.28a.25.25,0,0,1,.24-.17h40.85a.26.26,0,0,1,.24.17l4.12,13.2,1.26.48c1.18.44,2.42,1,3.8,1.58l1.22.54L213,104.67a.24.24,0,0,1,.29,0L233,124.47a.25.25,0,0,1,0,.36A.26.26,0,0,1,232.85,124.9Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "169.645px 177.21px 0px"
    },
    id: "el6zyzqod9017",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-38",
    style: {
      transformOrigin: "270.695px 272.887px 0px"
    },
    className: "animable"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.34,185.39c3.13,4,6.06,8,8.92,12.13s5.58,8.35,8.15,12.75c.65,1.09,1.27,2.23,1.9,3.35a13.49,13.49,0,0,1,1.57,5.49,28.65,28.65,0,0,1-.84,8.67,61.61,61.61,0,0,1-5.62,14.61l-5.15-2a115.55,115.55,0,0,0,2.21-14,23.47,23.47,0,0,0-.2-6.1,3.71,3.71,0,0,0-.61-1.56c-.66-1-1.3-2-2-3-2.71-4-5.58-7.91-8.47-11.84l-8.69-11.78Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "319.217px 213.89px 0px"
    },
    id: "el9uib3o72vjo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.91,239.81l-2.66,4.76,9.28,1.37s1-4-1.33-6.76Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "323.997px 242.56px 0px"
    },
    id: "elxo2ncrvw7qc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.85 250.9 325.58 251.68 328.53 245.94 319.25 244.57 317.85 250.9",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "323.19px 248.125px 0px"
    },
    id: "el923prjok9w4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343,279.3l2.76-14.69a6.55,6.55,0,0,1,7.63-5.23l23.17,4.34a30.62,30.62,0,0,0-46.73-16.44L224.71,185.06A30.62,30.62,0,0,0,170,163.76l23.17,4.34a6.57,6.57,0,0,1,5.22,7.64l-2.76,14.7a6.56,6.56,0,0,1-7.63,5.23l-23.17-4.35a30.62,30.62,0,0,0,47,16.27l104.91,62.1a30.62,30.62,0,0,0,54.66,21.6l-23.17-4.35A6.57,6.57,0,0,1,343,279.3Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "270.695px 227.508px 0px"
    },
    id: "elnsmv4lvgdb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elpfp9ooj2pdj"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 220.75,
    width: 105.56,
    height: 13.34,
    rx: 3.26,
    style: {
      fill: "rgb(fill)",
      transformOrigin: "270.8px 227.42px 0px",
      transform: "rotate(30.62deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elu2y3omqrno"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.02,
    y: 220.75,
    width: 105.56,
    height: 13.34,
    rx: 3.26,
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.2,
      transformOrigin: "270.8px 227.42px 0px",
      transform: "rotate(30.62deg)"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.74,154.31c-.1.59-.48,1-.86,1s-.62-.59-.53-1.17.48-1,.86-.95S277.83,153.73,277.74,154.31Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.045px 154.248px 0px"
    },
    id: "elhooaungyx9u",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.31,155.33a21.22,21.22,0,0,1-3.58,4.57,3.44,3.44,0,0,0,2.72,1Z",
    style: {
      fill: "rgb(255, 86, 82)",
      transformOrigin: "275.52px 158.121px 0px"
    },
    id: "el3xe0ztp7mpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.37,151.4a.33.33,0,0,1-.24-.1,2.75,2.75,0,0,0-2.37-.83.35.35,0,0,1-.42-.27.34.34,0,0,1,.27-.41,3.43,3.43,0,0,1,3,1,.37.37,0,0,1,0,.5A.39.39,0,0,1,280.37,151.4Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "279.019px 150.574px 0px"
    },
    id: "elks79r0rqoce",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.27,160.76c-1,5.38-2.1,15.23,1.66,18.81,0,0-1.47,5.45-11.46,5.45-11,0-5.25-5.45-5.25-5.45,6-1.43,5.84-5.88,4.8-10Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "289.824px 172.89px 0px"
    },
    id: "el2x1ffi3wn9v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,183.61a1.93,1.93,0,0,1-.27-.58c-.84-3.19-4.37-5.68-8.95-5.81-4.83-.12-10.28.46-13.5,3.12-1.42,1.17.15,2.88.15,2.88Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "292.343px 180.408px 0px"
    },
    id: "elejze2iy5seb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elm8edlyyz2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304,183.61a1.93,1.93,0,0,1-.27-.58c-.84-3.19-4.37-5.68-8.95-5.81-4.83-.12-10.28.46-13.5,3.12-1.42,1.17.15,2.88.15,2.88Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "292.343px 180.408px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M339.31,384.83h-.07a.71.71,0,0,1-.6-.57.82.82,0,0,1,.09-.68c.56-.95,3-1.45,3.07-1.47a.18.18,0,0,1,.18.07.19.19,0,0,1,0,.19C341.61,383,340.24,384.83,339.31,384.83Zm2.15-2.29c-.8.21-2.1.64-2.43,1.21a.42.42,0,0,0,0,.39c.09.31.25.33.29.34C339.77,384.54,340.83,383.46,341.46,382.54Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "340.304px 383.468px 0px"
    },
    id: "elh45reovko6k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.64,382.58c-.91,0-1.93-.17-2.24-.61a.58.58,0,0,1,.06-.72,1,1,0,0,1,.67-.38c1.1-.12,2.75,1.21,2.82,1.27a.17.17,0,0,1-.06.3A4.63,4.63,0,0,1,340.64,382.58Zm-1.34-1.37h-.13a.57.57,0,0,0-.43.24c-.14.18-.08.27-.05.3.28.41,1.81.57,2.74.42A4.63,4.63,0,0,0,339.3,381.21Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "340.16px 381.722px 0px"
    },
    id: "elp6yi72ysdk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.68,409.11c-.94,0-1.85-.13-2.16-.55a.66.66,0,0,1,0-.76.89.89,0,0,1,.56-.41c1.22-.33,3.79,1.13,3.9,1.2a.17.17,0,0,1,.08.18.18.18,0,0,1-.14.14A13.29,13.29,0,0,1,266.68,409.11Zm-1.17-1.42a1.15,1.15,0,0,0-.33,0,.51.51,0,0,0-.34.24c-.13.22-.08.33,0,.39.34.47,2.2.48,3.57.29A7.87,7.87,0,0,0,265.51,407.69Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "266.732px 408.226px 0px"
    },
    id: "elv2k0i9cnpbq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.9,408.91h-.07c-.89-.4-2.65-2-2.51-2.82,0-.2.17-.44.65-.49a1.3,1.3,0,0,1,1,.3c.94.77,1.13,2.75,1.14,2.83a.17.17,0,0,1-.07.16A.19.19,0,0,1,268.9,408.91Zm-1.79-3H267c-.31,0-.33.15-.34.19-.08.5,1.12,1.75,2,2.29a4.08,4.08,0,0,0-1-2.26A.92.92,0,0,0,267.11,405.93Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "267.712px 407.253px 0px"
    },
    id: "elkm13b0k33dh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.98 408.74 269.63 408.74 268.9 391.73 276.25 391.73 276.98 408.74",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "272.94px 400.235px 0px"
    },
    id: "el45ui11yo69x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.41 377.05 342.45 381.35 328.39 370.51 334.35 366.22 348.41 377.05",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "338.4px 373.785px 0px"
    },
    id: "elqzdh18j30yd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.6,381.29l5.72-6a.63.63,0,0,1,.79-.1l5.72,3.47a1.09,1.09,0,0,1,.2,1.68c-2,2.05-3.13,2.94-5.64,5.56-1.55,1.61-5.75,7.27-7.89,9.5s-4.61.4-3.94-.7c3-4.94,4.46-9.84,4.54-12.28A1.81,1.81,0,0,1,341.6,381.29Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "345.393px 385.775px 0px"
    },
    id: "elnmpbsnregm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.68,407.89h8a.64.64,0,0,1,.63.5l1.45,6.53a1.07,1.07,0,0,1-1.06,1.3c-2.89,0-7.07-.21-10.71-.21-4.26,0-7.93.23-12.92.23-3,0-3.85-3.05-2.59-3.33,5.75-1.25,10.44-1.39,15.41-4.45A3.41,3.41,0,0,1,269.68,407.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "265.851px 412.065px 0px"
    },
    id: "el5yyghy2j32g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.06,195.08c1,1.85,2.13,3.64,3.22,5.31,1.88,2.89,3.7,5.39,5,7.11,1.17,1.55,1.92,2.46,1.92,2.46L328,199.87s-9-17.52-15.93-18.64C304.94,180.1,298.41,186.78,303.06,195.08Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "314.748px 195.532px 0px"
    },
    id: "el02iv5hydeqzx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "ele43z9wadk2b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.06,195.08c1,1.85,2.13,3.64,3.22,5.31,1.88,2.89,3.7,5.39,5,7.11,1.17,1.55,1.92,2.46,1.92,2.46L328,199.87s-9-17.52-15.93-18.64C304.94,180.1,298.41,186.78,303.06,195.08Z",
    style: {
      opacity: 0.5,
      transformOrigin: "314.748px 195.532px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M306.28,200.39c1.88,2.89,3.7,5.39,5,7.11-.15-3.44-.86-9-3.53-13.24C306.78,195.22,306.39,197.7,306.28,200.39Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "308.78px 200.88px 0px"
    },
    id: "elbqfvi3y5ar",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elq0xm0hheg8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.28,200.39c1.88,2.89,3.7,5.39,5,7.11-.15-3.44-.86-9-3.53-13.24C306.78,195.22,306.39,197.7,306.28,200.39Z",
    style: {
      opacity: 0.6,
      transformOrigin: "308.78px 200.88px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,205.56c0,2.5.06,5.25.2,8.28.36,8.24,1.26,18.51,3,31.27h39.29c.27-6-3.52-35.46,2.3-63.88a102.86,102.86,0,0,0-13.16-1.66,145.27,145.27,0,0,0-16.7,0,74.93,74.93,0,0,0-11.3,2S267.3,185.7,267.31,205.56Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "289.705px 212.22px 0px"
    },
    id: "eletjkmt70su",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el51fotyzdg7y"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.31,205.56c0,2.5.06,5.25.2,8.28.36,8.24,1.26,18.51,3,31.27h39.29c.27-6-3.52-35.46,2.3-63.88a102.86,102.86,0,0,0-13.16-1.66,145.27,145.27,0,0,0-16.7,0,74.93,74.93,0,0,0-11.3,2S267.3,185.7,267.31,205.56Z",
    style: {
      opacity: 0.5,
      transformOrigin: "289.705px 212.22px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.31,205.56c0,2.5.06,5.25.2,8.28,4.61-4.5,4.92-13.69,4.92-13.69Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "269.87px 206.995px 0px"
    },
    id: "el1qihacjfkge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elrhcg9v2q4va"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.31,205.56c0,2.5.06,5.25.2,8.28,4.61-4.5,4.92-13.69,4.92-13.69Z",
    style: {
      opacity: 0.6,
      transformOrigin: "269.87px 206.995px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275.5,194.15a35,35,0,0,1-2.5,3.64c-.83,1.08-1.66,2.1-2.51,3.11-1.69,2-3.5,3.93-5.34,5.8a74.19,74.19,0,0,1-12.45,10.16,40.75,40.75,0,0,1-3.75,2.08l-.51.24-.25.12-.31.13a11.41,11.41,0,0,1-1.52.52l-.73.19-.7.12a11.14,11.14,0,0,1-1.35.15,26.08,26.08,0,0,1-8.88-1.25,58.53,58.53,0,0,1-14.35-6.71l2.37-5a106.47,106.47,0,0,0,13.87,3.16,19.68,19.68,0,0,0,6,.08,2.78,2.78,0,0,0,.5-.13l.22-.06.16-.07c.13,0,.16-.1.24-.13l.6-.35a29.76,29.76,0,0,0,2.67-1.75,76.29,76.29,0,0,0,10.25-9.28c1.63-1.71,3.2-3.5,4.73-5.28.76-.9,1.5-1.8,2.19-2.71s1.4-1.84,1.81-2.48Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "247.925px 204.437px 0px"
    },
    id: "el97wzbkobala",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.8,208.8,218.92,203l-3.32,8.48s4.21,2,7.49.84Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "219.7px 207.841px 0px"
    },
    id: "elu7viro5xi4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.76 201.73 210.4 208.5 215.6 211.47 218.92 202.99 211.76 201.73",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "214.66px 206.6px 0px"
    },
    id: "eltmx5oke789t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,190.17c-.87,7-16.75,21.75-16.75,21.75l-14.3-11.34a82.57,82.57,0,0,1,12.52-14.53C273.22,177.07,282.44,181.81,281.39,190.17Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "265.906px 196.561px 0px"
    },
    id: "elv19bbgwuqi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el49zo3pamxr4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.39,190.17c-.87,7-16.75,21.75-16.75,21.75l-14.3-11.34a82.57,82.57,0,0,1,12.52-14.53C273.22,177.07,282.44,181.81,281.39,190.17Z",
    style: {
      opacity: 0.5,
      transformOrigin: "265.906px 196.561px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269,237.42c14.27,0,17.53-16.14,18.28-23.07a87.14,87.14,0,0,0-12.27-33,.89.89,0,0,1,.59-1.35l3.13-.58a.93.93,0,0,1,.93.41c8.59,13.75,11.4,25.41,12.31,31.41h2.56c2.62-5.7,8.39-18.69,7.92-30.86a.88.88,0,0,1,1-.93l3.36.33a.88.88,0,0,1,.82.84c.49,11.73-6.14,28-8.69,33.17.87,19.14,11.52,22.45,11.52,22.45a72,72,0,0,1-.63,14.25c-22.55,3.66-33.79,1.43-40.22-1.23C270.11,244.45,269.21,241.08,269,237.42Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "289.785px 215.909px 0px"
    },
    id: "elauek199c3wt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3tj82ba2flt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269,237.42c14.27,0,17.53-16.14,18.28-23.07a87.14,87.14,0,0,0-12.27-33,.89.89,0,0,1,.59-1.35l3.13-.58a.93.93,0,0,1,.93.41c8.59,13.75,11.4,25.41,12.31,31.41h2.56c2.62-5.7,8.39-18.69,7.92-30.86a.88.88,0,0,1,1-.93l3.36.33a.88.88,0,0,1,.82.84c.49,11.73-6.14,28-8.69,33.17.87,19.14,11.52,22.45,11.52,22.45a72,72,0,0,1-.63,14.25c-22.55,3.66-33.79,1.43-40.22-1.23C270.11,244.45,269.21,241.08,269,237.42Z",
    style: {
      opacity: 0.3,
      transformOrigin: "289.785px 215.909px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "268.9 391.73 269.28 400.5 276.63 400.5 276.25 391.73 268.9 391.73",
    style: {
      fill: "rgb(255, 86, 82)",
      transformOrigin: "272.765px 396.115px 0px"
    },
    id: "elx0b4hvxodo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "334.36 366.22 328.4 370.52 335.65 376.1 341.61 371.8 334.36 366.22",
    style: {
      fill: "rgb(255, 86, 82)",
      transformOrigin: "335.005px 371.16px 0px"
    },
    id: "elyb9i66ydcgs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.46,156.13c-1.57,7.12-2.13,11.37-6.34,14.49-6.33,4.7-14.69,0-15.28-7.43-.53-6.7,2.12-17.22,9.61-19A10,10,0,0,1,297.46,156.13Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "286.74px 158.218px 0px"
    },
    id: "ellg3y5tr1vwq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.81,145.08c6.25.17,3.68,3.46.55,5.27,0,0,3.61,1.73,1.75,5.86-2.82,6.27-8.22,13.16-13.73,12.78-6.86-.47-8.81-7.93-8.56-15.29-3.62-3.41-4.23-5.29-4.79-9.39C277.9,136.18,283,131.71,303.81,145.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "293.262px 152.789px 0px"
    },
    id: "elxqtm5ze9yrk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.76,131.38a16.66,16.66,0,0,1,12,20.27l-32.29-8.24A16.67,16.67,0,0,1,295.76,131.38Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "291.877px 141.254px 0px"
    },
    id: "el3ulvs6i2xhs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1ztily134xt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.76,131.38a16.66,16.66,0,0,1,12,20.27l-32.29-8.24A16.67,16.67,0,0,1,295.76,131.38Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.5,
      transformOrigin: "291.877px 141.254px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M302.14,151.67a1.44,1.44,0,0,1-1.41-1.82,13.34,13.34,0,0,0-1.91-10.69,16.14,16.14,0,0,0-9.63-6.75,1.46,1.46,0,0,1,.72-2.83,19.05,19.05,0,0,1,11.35,8,16.24,16.24,0,0,1,2.3,13A1.46,1.46,0,0,1,302.14,151.67Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "296.064px 140.602px 0px"
    },
    id: "el2k590flonr9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elr3bxzl77er"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.14,151.67a1.44,1.44,0,0,1-1.41-1.82,13.34,13.34,0,0,0-1.91-10.69,16.14,16.14,0,0,0-9.63-6.75,1.46,1.46,0,0,1,.72-2.83,19.05,19.05,0,0,1,11.35,8,16.24,16.24,0,0,1,2.3,13A1.46,1.46,0,0,1,302.14,151.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "296.064px 140.602px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M271,143.84l38,9.7a1.54,1.54,0,0,0,1.87-1.11h0a1.55,1.55,0,0,0-1.11-1.88l-38-9.7a1.55,1.55,0,0,0-1.88,1.12h0A1.54,1.54,0,0,0,271,143.84Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "290.376px 147.195px 0px"
    },
    id: "elktlwknykkjj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el43npot3avpq"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271,143.84l38,9.7a1.54,1.54,0,0,0,1.87-1.11h0a1.55,1.55,0,0,0-1.11-1.88l-38-9.7a1.55,1.55,0,0,0-1.88,1.12h0A1.54,1.54,0,0,0,271,143.84Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.3,
      transformOrigin: "290.376px 147.195px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M287.57,155.46a8.16,8.16,0,0,1-2.22,4.8c-1.66,1.71-3.3.56-3.51-1.6-.19-1.94.45-5.17,2.44-6.07S287.78,153.29,287.57,155.46Z",
    style: {
      fill: "rgb(255, 139, 123)",
      transformOrigin: "284.699px 156.71px 0px"
    },
    id: "elabuk5lwllnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.43,245.11s-.85,52.28,5.72,72.78C300.56,350.36,332,376.66,332,376.66l11.24-8.11S317.06,346.33,312.26,319c-4.31-24.57-2.48-53.8-2.48-73.87Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "313.817px 310.885px 0px"
    },
    id: "elgtlt2t9pbbh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el1djprvt2gyn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.43,245.11s-.85,52.28,5.72,72.78C300.56,350.36,332,376.66,332,376.66l11.24-8.11S317.06,346.33,312.26,319c-4.31-24.57-2.48-53.8-2.48-73.87Z",
    style: {
      opacity: 0.3,
      transformOrigin: "313.817px 310.885px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M291.76,254.09c1.39,9.42-3.52,35.65-5.22,44.24-1.78-16.06-2.11-35.11-2.14-45.51C288,250.38,291.12,249.75,291.76,254.09Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "288.202px 274.618px 0px"
    },
    id: "elb4y2iudorgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el13jjou3hcve9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.76,254.09c1.39,9.42-3.52,35.65-5.22,44.24-1.78-16.06-2.11-35.11-2.14-45.51C288,250.38,291.12,249.75,291.76,254.09Z",
    style: {
      opacity: 0.4,
      transformOrigin: "288.202px 274.618px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M327.19,374.29c-.05,0,4.62,2.75,4.62,2.75l12.27-8.86L340,365.05Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "335.635px 371.045px 0px"
    },
    id: "elh9pb5dbdydr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el519h1r0r5vw"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.19,374.29c-.05,0,4.62,2.75,4.62,2.75l12.27-8.86L340,365.05Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "335.635px 371.045px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M270.49,245.11s-11.07,46.9-11.85,69.3c-.87,25.13,7.9,84.39,7.9,84.39H279s1.54-59.72,2.09-82.61c.6-24.95,15.25-71.08,15.25-71.08Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "277.46px 321.955px 0px"
    },
    id: "elgqc8z015tfc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elxed41tg38tj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.49,245.11s-11.07,46.9-11.85,69.3c-.87,25.13,7.9,84.39,7.9,84.39H279s1.54-59.72,2.09-82.61c.6-24.95,15.25-71.08,15.25-71.08Z",
    style: {
      opacity: 0.3,
      transformOrigin: "277.46px 321.955px 0px"
    },
    className: "animable"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.14,393.84c-.05,0,.71,5.17.71,5.17H280l.41-4.61Z",
    style: {
      fill: "rgb(fill)",
      transformOrigin: "272.274px 396.425px 0px"
    },
    id: "el09ruotw9ptog",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elfpxmgnj7y9s"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.14,393.84c-.05,0,.71,5.17.71,5.17H280l.41-4.61Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.4,
      transformOrigin: "272.274px 396.425px 0px"
    },
    className: "animable"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b45d70ea.svg";
export { ForwardRef as ReactComponent };